var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"payment-layout__summary__agreement summary-page__upgrade-message-gap",domProps:{"innerHTML":_vm._s(_vm.displayMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }